// room gordion
export type RoomGordionChairFamilyOption = 'm4' | 'ori';

export const RoomGordionChairFamilyOptions = [
  'm4',
  'ori',
];
export type RoomGordionBossTableOption = 'gordion_tekil_masa_yyy' | 'gordion_kesonlu_masa_yyy';
export const RoomGordionBossTableOptions = [{
  name:'Tekli',
  id:'gordion_tekil_masa_yyy',
},
  {
    name:'Kesonlu',
    id:'gordion_kesonlu_masa_yyy',
  }];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/constants.ts